import React, { useState } from "react";
import * as styles from "../styles/components/fc-pricing.module.css";
import Container from "./container";
import Icon from "./icon";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";

const FcPricing = (props) => {
  const {
    _key,
    title,
    pricingPlans,
    subtitle,
    disclaimer,
    purewebExtendedRealityText,
    purewebRealityText,
  } = props;

  // State to track the active category
  const [activeCategory, setActiveCategory] = useState("pureweb-reality");

  // Filter the pricing plans based on the active category

  const pureWebRealityPlans = pricingPlans.filter(
    (plan) => plan.pricing.category === "pureweb-reality"
  );

  const pureWebExtendedRealityPlans = pricingPlans.filter(
    (plan) => plan.pricing.category === "pureweb-extended-reality"
  );

  return (
    <div className={styles.root} key={_key}>
      <Container>
        <h1 className={cn(styles.title, "color-palette-color")}>{subtitle}</h1>
        <div className={styles.priceContainer}>
          <div
            style={{ zIndex: activeCategory === "pureweb-reality" ? 2 : 0 }}
            className={styles.priceWrapper}
          >
            <button
              className={cn(styles.activeButton, "color-palette-pseudo-bg btn")}
              onClick={() => setActiveCategory("pureweb-reality")}
            >
              <span className={styles.activeText}>PureWeb Reality</span>
              <span className={styles.activeDescription}>
                {purewebRealityText}
              </span>
            </button>
            <button
              className={cn(
                styles.inactiveButton,
                "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke btn"
              )}
              onClick={() => setActiveCategory("pureweb-extended-reality")}
            >
              <span className={styles.activeText}>
                PureWeb Extended Reality
              </span>
              <span className={styles.activeDescription}>
                {purewebExtendedRealityText}
              </span>
            </button>
          </div>
          <div
            style={{ zIndex: activeCategory === "pureweb-reality" ? 0 : 2 }}
            className={styles.priceWrapper}
          >
            <button
              className={cn(
                styles.inactiveButton,
                "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke btn"
              )}
              onClick={() => setActiveCategory("pureweb-reality")}
            >
              <span className={styles.activeText}>PureWeb Reality</span>
              <span className={styles.activeDescription}>
                {purewebRealityText}
              </span>
            </button>
            <button
              className={cn(styles.activeButton, "color-palette-pseudo-bg btn")}
              onClick={() => setActiveCategory("pureweb-extended-reality")}
            >
              <span className={styles.activeText}>
                PureWeb Extended Reality
              </span>
              <span className={styles.activeDescription}>
                {purewebExtendedRealityText}
              </span>
            </button>
          </div>
        </div>
        <div className={activeCategory === 'pureweb-reality' ?  styles.pricingPlanContainer : styles.pricingPlanContainer2}>
          <div  style={{ zIndex: activeCategory === "pureweb-reality" ? 2 : -1, visibility: activeCategory === "pureweb-reality" ? 'visible' :'hidden' }}  className={styles.pricingPlans}>
            {pureWebRealityPlans.map((plan, index) => {
              const { button } = plan.pricing.callToAction;
              return (
                <div
                  className={cn(styles.pricingPlan, "color-palette-border")}
                  key={index}
                >
                  <h2 className={cn(styles.planTitle, "color-palette-color")}>
                    {plan.pricing.name}
                  </h2>
                  <p className={styles.startingText}>Starting at</p>
                  <p className={cn(styles.planPrice, "color-palette-color")}>
                    {plan.pricing.price}
                    {plan.pricing.price !== "Custom" && (
                      <span
                        className={cn(
                          styles.planPricePeriod,
                          "color-palette-color"
                        )}
                      >
                        /mo
                      </span>
                    )}
                  </p>
                  <p className={styles.planDescription}>
                    {plan.pricing.description}
                  </p>
                  <div className={styles.planEndBorder} />
                  <div className={styles.planFeatures}>
                    {plan.pricing.features.map((feature, index) => {
                      return (
                        <div key={index}>
                          <div
                            className={cn(
                              styles.featureMain,
                              "color-palette-svg-fill"
                            )}
                          >
                            <Icon symbol="check-circle" />
                            <p>{feature.name}</p>
                          </div>
                          <div className={styles.featureListMain}>
                            {feature.featureList.map((list, index) => {
                              return (
                                <div
                                  key={index}
                                  className={cn(
                                    styles.featureList,
                                    "color-palette-svg-fill"
                                  )}
                                >
                                  <Icon symbol="list-triangle" />
                                  <p>{list}</p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {button && button.url && (
                    <div className={styles.callToAction}>
                      {button.blank ? (
                        <a
                          href={button.url}
                          className={cn(
                            "btn",
                            button.secondaryButton
                              ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke"
                              : "color-palette-pseudo-bg"
                          )}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {button.text}
                          <Icon symbol="arrow-right" />
                        </a>
                      ) : (
                        <Link
                          to={button.url}
                          className={cn(
                            "btn",
                            button.secondaryButton
                              ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke"
                              : "color-palette-pseudo-bg"
                          )}
                        >
                          {button.text}
                          <Icon symbol="arrow-right" />
                        </Link>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div  style={{ zIndex: activeCategory === "pureweb-reality" ? -1 : 2, visibility: activeCategory === "pureweb-reality" ? 'hidden' :'visible'  }} className={styles.pricingPlans}>
          {pureWebExtendedRealityPlans.map((plan, index) => {
            const { button } = plan.pricing.callToAction;
            return (
              <div
                className={cn(styles.pricingPlan, "color-palette-border")}
                key={index}
              >
                <h2 className={cn(styles.planTitle, "color-palette-color")}>
                  {plan.pricing.name}
                </h2>
                <p className={styles.startingText}>Starting at</p>
                <p className={cn(styles.planPrice, "color-palette-color")}>
                  {plan.pricing.price}
                  {plan.pricing.price !== "Custom" && (
                    <span
                      className={cn(
                        styles.planPricePeriod,
                        "color-palette-color"
                      )}
                    >
                      /mo
                    </span>
                  )}
                </p>
                <p className={styles.planDescription}>
                  {plan.pricing.description}
                </p>
                <div className={styles.planEndBorder} />
                <div className={styles.planFeatures}>
                  {plan.pricing.features.map((feature, index) => {
                    return (
                      <div key={index}>
                        <div
                          className={cn(
                            styles.featureMain,
                            "color-palette-svg-fill"
                          )}
                        >
                          <Icon symbol="check-circle" />
                          <p>{feature.name}</p>
                        </div>
                        <div className={styles.featureListMain}>
                          {feature.featureList.map((list, index) => {
                            return (
                              <div
                                key={index}
                                className={cn(
                                  styles.featureList,
                                  "color-palette-svg-fill"
                                )}
                              >
                                <Icon symbol="list-triangle" />
                                <p>{list}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {button && button.url && (
                  <div className={styles.callToAction}>
                    {button.blank ? (
                      <a
                        href={button.url}
                        className={cn(
                          "btn",
                          button.secondaryButton
                            ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke"
                            : "color-palette-pseudo-bg"
                        )}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {button.text}
                        <Icon symbol="arrow-right" />
                      </a>
                    ) : (
                      <Link
                        to={button.url}
                        className={cn(
                          "btn",
                          button.secondaryButton
                            ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke"
                            : "color-palette-pseudo-bg"
                        )}
                      >
                        {button.text}
                        <Icon symbol="arrow-right" />
                      </Link>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        </div>

        
        <p style={{ textAlign: "center" }} className={styles.startingText}>
          {disclaimer}
        </p>
      </Container>
    </div>
  );
};

export default FcPricing;
